import usePrivateAxios from "@/common/api/usePrivateAxios"
import { PrivateCompanyLeadData } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead"
import { useMutation, UseMutationResult } from "@tanstack/react-query"
import { AxiosResponse } from "axios"

interface UseCreateContactProps {
  id?: string
  onSuccess?: (response: AxiosResponse<{ data: PrivateCompanyLeadData }, any>) => void
  onError?: () => void
}

const useCreatePrivateCompanyLeadContact = ({ id, onSuccess, onError }: UseCreateContactProps): UseMutationResult<AxiosResponse<{ data: PrivateCompanyLeadData }, any>, Error, void, unknown> => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadContact'],
    mutationFn: async () => {
      const private_company_lead = {
        contacts_attributes: [
          { _create: true }
        ]
      }

      return privateAxios.put(`/funnel/private_company_leads/${id}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useCreatePrivateCompanyLeadContact